export default __webpack_public_path__ + "static/media/78034895772781323454465622640213547173484445148962033197596468187897006979.gif.5b8d9c28.mp4";